export default __webpack_public_path__ + "static/media/jan2024-5.535ecfde.jpg";